import { Api } from "@relode/core";
import {
    MarketResearchCompensationResponse,
    MarketResearchDiversityResponse,
    MarketResearchRequest,
    MarketResearchShareResponse,
    MarketResearchSummaryResponse,
    MarketResearchSupplyDemandResponse,
} from "@relode/core/backend/marketResearch";

import { JobManagerContactResponse } from "../../shared";

const function_name = (name: string) =>
    `client.backend.controllers.marketResearch.marketResearchService.${name}`;

export const marketResearchService = {
    getJobCompensation: async (jobId: number) => {
        const url = `/jobs/${jobId}/market-research/compensation`;
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getJobCompensation"),
                data: { jobId },
            })
            .post<MarketResearchCompensationResponse>();

        return result;
    },

    getJobSupplyDemand: async (jobId: number) => {
        const url = `/jobs/${jobId}/market-research/supply-demand`;
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getJobSupplyDemand"),
                data: { jobId },
            })
            .post<MarketResearchSupplyDemandResponse>();

        return result;
    },

    getJobDiversity: async (jobId: number) => {
        const url = `/jobs/${jobId}/market-research/diversity`;
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getJobDiversity"),
                data: { jobId },
            })
            .post<MarketResearchDiversityResponse>();

        return result;
    },
    getJobShare: async (jobId: number) => {
        const url = `/jobs/${jobId}/market-research/share`;
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getJobShare"),
                data: { jobId },
            })
            .post<MarketResearchShareResponse>();

        return result;
    },

    getJobSummary: async (jobId: number) => {
        const url = `/jobs/${jobId}/market-research/summary`;
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getJobSummary"),
                data: { jobId },
            })
            .post<MarketResearchSummaryResponse>();

        return result;
    },

    getCompensation: async (request: MarketResearchRequest) => {
        const url = "/market-research/compensation";
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getCompensation"),
                data: { request },
            })
            .post<MarketResearchCompensationResponse>(request);

        return result;
    },

    getSupplyDemand: async (request: MarketResearchRequest) => {
        const url = "/market-research/supply-demand";
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getSupplyDemand"),
                data: { request },
            })
            .post<MarketResearchSupplyDemandResponse>(request);

        return result;
    },

    getDiversity: async (request: MarketResearchRequest) => {
        const url = "/market-research/diversity";
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getDiversity"),
                data: { request },
            })
            .post<MarketResearchDiversityResponse>(request);

        return result;
    },
    getShare: async (request: MarketResearchRequest) => {
        const url = "/market-research/share";
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getShare"),
                data: { request },
            })
            .post<MarketResearchShareResponse>(request);

        return result;
    },

    getSummary: async (request: MarketResearchRequest) => {
        const url = "/market-research/summary";
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getSummary"),
                data: { request },
            })
            .post<MarketResearchSummaryResponse>(request);

        return result;
    },

    getJobManagerInfo: async () => {
        const url = "/dashboard/jobManager";
        const result = Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: function_name("getJobManagerInfo"),
            })
            .get<JobManagerContactResponse>();

        return result;
    },
};
